const Slogan = (props) => {
    return (
        <div>
            <div className='flex items-center content-center'>
                <div className='text-center flex-grow-0 flex-shrink-0'>
                    <img src={props.img} className='w-full' alt='test' width={90}/>
                </div>
                <div className='slogan-text flex-grow'>
                    <div className='font-bold'>
                        {props.title}
                    </div>
                    <div className="text-sm">
                        {props.text}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Slogan